import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_ROLE_DEFINITIONS,
  ADD_NEW_ROLE_DEFINITION,
  UPDATE_ROLE_DEFINITION,
  DELETE_ROLE_DEFINITION,
  PAGE_OPERATION_LIST,
  PAGE_OPERATION_LIST_FOR_VALUE,

} from "./actionTypes"

import {

  getRoleDefinitionsSuccess,
  addRoleDefinitionSuccess,
  updateRoleDefinitionSuccess,
  deleteRoleDefinitionSuccess,
  getPageOperationListForRoleDefinitionSuccess,
  getPageOperationForValueListSuccess,
  roleDefinitionsApiError

} from "./actions"

import {

  getRoleDefinitions,
  addNewRoleDefinition,
  updateRoleDefinition,
  deleteRoleDefinition,
  getPageOperationListForRoleDefinition,
  getPageOperationForValueList,

} from "../../../helpers/backend_helper/backend_helper"

import { toast, Zoom } from "react-toastify";
import i18n from 'i18n';

function* fetchRoleDefinitions() {
  try {
    const response = yield call(getRoleDefinitions)
    yield put(getRoleDefinitionsSuccess(response))
  } catch (error) {
    yield put(roleDefinitionsApiError(error))
  }
}

function* onAddNewRoleDefinition({ payload: roleDefinition }) {
  try {
    const response = yield call(addNewRoleDefinition, roleDefinition)
    yield put(addRoleDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {

    yield put(roleDefinitionsApiError(error))
  }
}

function* onUpdateRoleDefinition({ payload: roleDefinition }) {
  try {
    const response = yield call(updateRoleDefinition, roleDefinition)
    yield put(updateRoleDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(roleDefinitionsApiError(error))
  }
}

function* onDeleteRoleDefinition({ payload: guid }) {
  try {
    const response = yield call(deleteRoleDefinition, guid)
    yield put(deleteRoleDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(roleDefinitionsApiError(error))
  }
}

function* fetchPageOperationDefinitions() {
  try {
    const response = yield call(getPageOperationListForRoleDefinition)
    yield put(getPageOperationListForRoleDefinitionSuccess(response))
  } catch (error) {
    yield put(roleDefinitionsApiError(error))
  }
}

function* fetchPageOperationDefinitionsForValue({ payload: guid }) {
  try {
    const response = yield call(getPageOperationForValueList, guid)
    yield put(getPageOperationForValueListSuccess(response))
  } catch (error) {
    yield put(roleDefinitionsApiError(error))
  }
}

function* roleManagementSaga() {
  yield takeEvery(GET_ROLE_DEFINITIONS, fetchRoleDefinitions)
  yield takeEvery(ADD_NEW_ROLE_DEFINITION, onAddNewRoleDefinition)
  yield takeEvery(UPDATE_ROLE_DEFINITION, onUpdateRoleDefinition)
  yield takeEvery(DELETE_ROLE_DEFINITION, onDeleteRoleDefinition)
  yield takeEvery(PAGE_OPERATION_LIST, fetchPageOperationDefinitions)
  yield takeEvery(PAGE_OPERATION_LIST_FOR_VALUE, fetchPageOperationDefinitionsForValue)

}

export default roleManagementSaga